const setFocusPoints = function (centerLocations) {
  return centerLocations.map((center) => {
    return { Latitude: center.latitude, Longitude: center.longitude }
  })
}

export default setFocusPoints
